export { default } from "ember-moment/helpers/moment-to-now";
